import React from 'react';
import { Car, Plane, Compass, Users, ArrowRight } from 'lucide-react';
import '../styles/Home.css';

const LOGO = "https://customer-assets.emergentagent.com/job_assist-vip-luxury/artifacts/9et8d8v2_A_logo_for_ASSIST_VIP_Luxury_Services_features_a-removebg-preview.png";

const LINKS = [
  { icon: Car, label: 'Private Chauffeur', desc: 'Hourly, daily & multi-day', service: 'chauffeur' },
  { icon: Plane, label: 'Airport Transfer', desc: 'Meet & greet, private pickup', service: 'airport' },
  { icon: Compass, label: 'Concierge & Yacht', desc: 'Restaurants, experiences, yacht', service: 'concierge' },
  { icon: Users, label: 'Group Transport', desc: 'Teams, events, delegations', service: 'groups' },
];

const InstagramLanding = () => {
  const openWhatsApp = (service = '') => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', { 'send_to': 'AW-17988005381/1jDyCIC78IQcEIXcrIFD' });
      window.gtag('event', 'instagram_link_click', { event_category: 'engagement', event_label: service || 'general' });
    }
    const msg = service
      ? encodeURIComponent(`Hello, I'm interested in your ${service} service. I found you on Instagram.`)
      : encodeURIComponent("Hello, I found you on Instagram. I'd like to learn about your services in Istanbul.");
    window.open(`https://wa.me/905447153414?text=${msg}`, '_blank');
  };

  return (
    <div className="luxury-site" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '48px 20px 60px' }}>
      <img src={LOGO} alt="ASSIST VIP" style={{ height: 80, marginBottom: 12 }} className="notranslate" translate="no" data-testid="instagram-logo" />
      <p style={{ fontSize: 11, letterSpacing: 3, color: 'var(--text-muted)', textTransform: 'uppercase', marginBottom: 8 }}>
        Istanbul · Since 2016
      </p>
      <p style={{ fontSize: 14, color: 'var(--text-secondary)', textAlign: 'center', maxWidth: 320, marginBottom: 36, lineHeight: 1.7 }}>
        Private chauffeur & concierge services for international travelers in Istanbul.
      </p>

      <div style={{ width: '100%', maxWidth: 400, display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 32 }}>
        {LINKS.map((link, i) => {
          const Icon = link.icon;
          return (
            <button
              key={i}
              onClick={() => openWhatsApp(link.label)}
              data-testid={`instagram-link-${link.service}`}
              style={{
                display: 'flex', alignItems: 'center', gap: 16,
                width: '100%', padding: '18px 20px',
                background: 'var(--bg-card)', border: '1px solid var(--border)',
                color: 'var(--text)', cursor: 'pointer',
                transition: 'all 0.3s',
                fontFamily: 'var(--font)',
              }}
              onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(197,160,89,0.3)'}
              onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border)'}
            >
              <Icon size={20} style={{ color: 'var(--champagne)', opacity: 0.7, flexShrink: 0 }} />
              <div style={{ textAlign: 'left', flex: 1 }}>
                <div style={{ fontSize: 15, fontWeight: 400, marginBottom: 2 }}>{link.label}</div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 300 }}>{link.desc}</div>
              </div>
              <ArrowRight size={16} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />
            </button>
          );
        })}
      </div>

      <button
        onClick={() => openWhatsApp()}
        data-testid="instagram-whatsapp-btn"
        style={{
          width: '100%', maxWidth: 400, padding: '16px',
          background: '#25D366', color: 'white', border: 'none',
          fontSize: 13, fontWeight: 600, letterSpacing: 2,
          textTransform: 'uppercase', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
          fontFamily: 'var(--font)',
          borderRadius: 0,
        }}
      >
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
          <path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492a.5.5 0 00.611.611l4.458-1.495A11.952 11.952 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-2.34 0-4.512-.728-6.305-1.97l-.44-.31-2.642.886.886-2.642-.31-.44A9.935 9.935 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
        </svg>
        WhatsApp Concierge
      </button>

      <a
        href="/"
        data-testid="instagram-page-link"
        style={{
          marginTop: 32, fontSize: 12, color: 'var(--text-muted)',
          letterSpacing: 2, textTransform: 'uppercase',
          textDecoration: 'none', transition: 'color 0.3s',
        }}
        onMouseEnter={e => e.currentTarget.style.color = 'var(--champagne)'}
        onMouseLeave={e => e.currentTarget.style.color = 'var(--text-muted)'}
      >
        Visit Full Website
      </a>
    </div>
  );
};

export default InstagramLanding;
